/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceSummaryRequest {
    getFixupPrototypeFunction() { return ComplianceSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceSummaryRequest>): ComplianceSummaryRequest {
        let obj = Object.assign(new ComplianceSummaryRequest(), model);
        ComplianceSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceSummaryRequest>): ComplianceSummaryRequest {
        if (!model) return null;
        return ComplianceSummaryRequest.newInstance(<ComplianceSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceSummaryRequest) {
        if (!obj) return;

        models.ComplianceSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceSummaryRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API
     */
    tenant_id: Array<string>;

    /**
     * Allowed services
     */
    services: Array<models.CloudServiceName>;

    /**
     * ID of the cloud account. This can be fetched from list cloud accounts API
     */
    cloud_accounts: Array<string>;

    /**
     * uri of compliance standard This can be fetched from the compliance standards list API call
     */
    compliance_uri: Array<string>;

}
